
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class JpmSecClassResultGrid extends SiteEntityGrid<JpmSecClassResultRow, any> {
        protected getColumnsKey() { return 'Data.JpmSecClassResult'; }
        protected getDialogType() { return JpmSecClassResultDialog; }
        protected getIdProperty() { return JpmSecClassResultRow.idProperty; }
        protected getLocalTextPrefix() { return JpmSecClassResultRow.localTextPrefix; }
        protected getService() { return JpmSecClassResultService.baseUrl; }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != 'clone-button');
            return buttons;
        }

        constructor(container: JQuery) {
            super(container);
        }
    }
}